import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { ToastContainer } from "react-toastify";
import RoomTable from "./roomTable";
import CustomLoader from "../../../common/commonComponents/Loader/loader";
import { masterServiceBaseUrl, getAPI } from "services/http";
import { Container, Button } from "reactstrap";
import { GetPagination } from "../../../common/commonComponents/pagination/pagination";
import HeaderInfo from '../header/headerInfo'
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

const res = [
  {
    id: 4,
    roomName: "Room 1",
    roomCode : "0001",
    examCapacity: "10",
    classCapacity : "15",
    status: "ACTIVE",
  },
];

const Room = (props) => {
  const { buildingId, floorId } = props.match.params;
  const buildingHeraderData =  useSelector(state => state.globalData.data)
  const [classArray, setclassArray] = useState([]);
  const [apiloader, setapiloader] = useState(false);
  const [state, setstate] = useState([]);
  const [serverData, setServerData] = useState([]);
  const [isSaveVisible, setisSaveVisible] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
    nextPage: null,
    previousPage: null,
    totalPage: null,
  });
  const pageSize = 10;

  const fetchClasses = async (url) => {
    setapiloader(true);
    getAPI(
      url,
      (data) => {
        setstate(data["data"]);
        setServerData(data["data"]);
        setPagination(data["data"]);
      },
      (data) => {
        failureToast(data["message"]);
        setapiloader(false);
      }
    );
  };

  const setPagination = (paramsdata) => {
    let n = pagination;
    if (paramsdata.length > pageSize) {
      n["nextPage"] = n.currentPage + 1;
    }
    if (n.currentPage > 1) {
      n.previousPage = n.currentPage - 1;
    }
    n["totalPage"] = Math.floor(paramsdata.length / pageSize);
    if (paramsdata.length % pageSize != 0) {
      n["totalPage"] += 1;
    }
    setpagination(n);
    setclassArray(
      paramsdata.slice(
        pagination.currentPage * pageSize - pageSize,
        pagination.currentPage * pageSize
      ) || []
    );
    setapiloader(false);
  };

  useEffect(() => {
    floorId && fetchClasses(`${masterServiceBaseUrl}/roomMaster/getRoomMasterByFloorMasterId/${floorId}`);
  }, [floorId]);

  return (
    <>
      {apiloader ? (
        <div
          className="mx-auto text-center py-5 my-5"
          style={{ height: "100vh" }}
        >
          <CustomLoader apiLoader={apiloader} />
        </div>
      ) : (
        <>
          <HeaderInfo data={buildingHeraderData} isFloor={false} onBack={()=>props.history.push(`/admin/building/${buildingId}/floors`)}/>
          <RoomTable
            fetchClasses={fetchClasses}
            setclassArray={setclassArray}
            classArray={classArray}
            isSaveVisible={isSaveVisible}
            setisSaveVisible={setisSaveVisible}
            serverData={serverData}
            floorMasterId={floorId}
            buildingHeraderData={buildingHeraderData}
          />
          {pagination.totalPage > 1 ? (
            <GetPagination
              isSaveVisible={isSaveVisible}
              fetchClasses={fetchClasses}
              setclassArray={setclassArray}
              pagination={pagination}
              setpagination={setpagination}
              pageSize={pageSize}
              state={state}
            />
          ) : null}
        </>
      )}
    </>
  );
};

export default Room;
